const m: Record<string, string> = {
  'howToBecomeButler.home': 'ホーム',
  'howToBecomeButler.title': '執事になるには｜未経験からプロを目指す完全ガイド',
  'howToBecomeButler.lead':
    '執事に必要な知識・技能・学び方・認定・仕事への進み方を、未経験の方にも分かるよう順に解説します。華やかな印象だけでなく、守秘・観察・段取り・反復という土台から現実的に考える案内です。',
  'howToBecomeButler.faq.title': '執事になるためのよくある質問',

  'howToBecomeButler.understand.title': '最初に知るべき執事の役割',
  'howToBecomeButler.understand.intro':
    '志す前に、映像や小説の華やかさだけを基準にしないことが大切です。現場では住まいの流れを静かに整え、依頼主の時間と安心を守ることが中心です。養成では何を担い何を担わないかを言葉で整理し、誤解のない出発点をつくります。',
  'howToBecomeButler.understand.h1': '暮らし全体を支える専門職',
  'howToBecomeButler.understand.p1':
    '役割は単一の家事に限りません。来客対応、予定調整、備品管理、食事や移動の準備など、暮らしの接点を横断して支えます。各作業が前後の予定や他担当とどうつながるかを意識し、滞りを先に減らす視点が求められます。表面的な丁寧さだけでなく、生活全体の安定を設計する姿勢が基盤です。',
  'howToBecomeButler.understand.h2': '指示の前に気づく観察力',
  'howToBecomeButler.understand.p2':
    '優れた対応は指示待ちだけでは生まれません。表情・持ち物・部屋の状態・時間帯の変化など、小さな手がかりから次の支援を予測します。先回りは押しつけにならないよう、確認の時機と距離感も同時に学びます。観察を勝手に断定せず、事実と推測を分けて伝える訓練が、信頼を損なわない土台になります。',
  'howToBecomeButler.understand.h3': '守秘と適切な距離感',
  'howToBecomeButler.understand.p3':
    '家庭や個人の空間に入る以上、見聞きした情報を外へ出さない姿勢は絶対条件です。会話の話題、来客の有無、生活習慣まで、業務上知り得た事柄は外で扱いません。親しみと馴れ馴れしさを混同しない距離感も重要です。丁寧でありながら立ち入らず、必要な報告だけを適切な相手へ届ける習慣を、入学前から意識すると学びが定着しやすくなります。',

  'howToBecomeButler.qualities.title': '身につけたい基礎資質',
  'howToBecomeButler.qualities.intro':
    '技術の前に、日々の振る舞いの質が問われます。言葉づかい、身だしなみ、時間厳守、記録の正確さは、どの現場でも共通する基礎です。才能より、同じ基準を淡々と守れるかが成長速度を左右します。養成では派手な成果より、再現性のある丁寧さを重視して指導します。',
  'howToBecomeButler.qualities.h1': '正確な所作と言葉づかい',
  'howToBecomeButler.qualities.p1':
    '立ち方、歩き方、物の渡し方、ドアの開閉にも、相手への印象が表れます。声の大きさや速度、敬語の選択も同様で、正しさだけでなく場に合った落ち着きが必要です。最初は型を忠実に繰り返し、癖を自覚するところから始めます。美しい所作は演技ではなく、周囲を妨げない実用技能として身につけます。',
  'howToBecomeButler.qualities.h2': '段取りと記録の習慣',
  'howToBecomeButler.qualities.p2':
    '用事が重なる場面では、頭の中だけの管理は抜け漏れを招きやすいです。優先順位を決め、所要時間を見積もり、終了内容を簡潔に残す習慣が安全につながります。記録は自分用だけでなく、引き継ぎや報告の材料にもなります。完璧な記憶に頼らず、誰でも追える形で残す意識を早期に育てることが大切です。',
  'howToBecomeButler.qualities.h3': '平常心と柔軟な対応',
  'howToBecomeButler.qualities.p3':
    '予定どおり進まない日こそ、落ち着いた判断が求められます。急な来客、天候の変化、備品不足など、想定外は日常的に起きます。焦って手順を飛ばさず、安全と礼儀を保ったまま代替案を選ぶ力が必要です。感情を出しすぎず、事実を整理して次の一手を決める練習を重ねると、現場で頼られる安定感が育ちます。',

  'howToBecomeButler.learn.title': '独学と専門教育の違い',
  'howToBecomeButler.learn.intro':
    '書籍や動画でも知識の入口には立てますが、所作の角度、声のトーン、判断の根拠までは一人で検証しにくいものです。専門教育では、示范・実践・指摘・再実施の循環で自己流のズレを早く修正できます。未経験の方ほど、客観的な目が入る環境で基礎を固める意味が大きくなります。',
  'howToBecomeButler.learn.h1': '知識は体系的に学ぶ',
  'howToBecomeButler.learn.p1':
    '礼儀、ハウスキーピング、テーブルサービス、衣裳や備品の扱い、コミュニケーションなど、領域は多岐にわたります。断片的に覚えると、現場で何を先にすべきかが曖昧になります。カリキュラムでは関連主題を順に扱い、手順の理由を理論と事例の両面から理解します。体系があると、初めての状況でも原則に立ち返って判断しやすくなります。',
  'howToBecomeButler.learn.h2': '実技は反復して身につける',
  'howToBecomeButler.learn.p2':
    '頭で理解しても、身体が追いつかなければ実務では使えません。配膳、案内、清掃の動線、荷物の扱いなどは、回数を重ねて初めて安定します。同じ課題を条件を変えて繰り返し、速さより正確さと静けさを優先します。疲れているときほど基本に戻る習慣が、本番で崩れにくい技能になります。',
  'howToBecomeButler.learn.h3': 'フィードバックを受ける',
  'howToBecomeButler.learn.p3':
    '自分では気づけない癖や、良かれと思った行動の副作用は、第三者の指摘で初めて見えます。指導者の具体的な改善点を受け取り、次回の実践で一つずつ直す循環が上達の近道です。指摘を人格否定と受け取らず、作業品質を上げる情報として扱う姿勢が重要です。質問の仕方自体も学びの一部として磨きます。',

  'howToBecomeButler.courses.title': '段階に応じた3つのコース',
  'howToBecomeButler.courses.intro':
    '学びの深さに応じ、エッセンシャル、アドバンス、マスターの三段階を用意しています。いずれも座学と実技を組み合わせ、修了時には各段階の認定へ進みます。経験値や目指す働き方に合わせて選び、無理な駆け足や基礎不足のまま進むことを避けられます。入学前に各コースの到達イメージを比較してください。',
  'howToBecomeButler.courses.h1': 'エッセンシャルコース',
  'howToBecomeButler.courses.p1':
    'エッセンシャルは8日間・48時間で、礼儀、基本動線、身だしなみ、報告の型など土台を集中的に身につけます。未経験の方が最初に全体像を把握するのに適した段階です。修了認定はアソシエイトです。短い期間だからこそ、毎回の復習と自宅での反復が成果を左右します。基礎用語と安全確認を確実に覚え、次の学びへ進む準備を整えます。',
  'howToBecomeButler.courses.h2': 'アドバンスコース',
  'howToBecomeButler.courses.p2':
    'アドバンスは12日間・72時間で、接遇の応用、複雑な段取り、複数業務の同時進行など、現場で揺らぎやすい場面への対応力を伸ばします。基礎を一通り理解したうえで、判断の根拠を言葉にしながら実技を深める構成です。修了認定はプロフェッショナルです。長い実習の中で、速度と丁寧さの両立、チーム内の情報共有の精度を高めていきます。',
  'howToBecomeButler.courses.h3': 'マスターコース',
  'howToBecomeButler.courses.p3':
    'マスターは16日間・96時間で、高度な状況判断、品質管理の視点、後進へ手順を示す力まで総合的に磨きます。自ら動くだけでなく、場全体を見渡して優先順位を再設計する訓練が増えます。修了認定はマスターです。長い行程だからこそ、体調管理と学習計画を自分で立てる責任も伴います。到達点は完成ではなく、自律的に改善し続けられる状態です。',

  'howToBecomeButler.assessment.title': '修了認定までの評価',
  'howToBecomeButler.assessment.intro':
    '成果は出席状況と試験で確認します。日々の実習で身につけた内容を、決められた条件の下で再現できるかが焦点です。評価は落とす関門ではなく、現場前に不足を可視化する仕組みです。基準を事前に理解し計画的に準備すれば、焦らず受験できます。',
  'howToBecomeButler.assessment.h1': '出席要件を満たす',
  'howToBecomeButler.assessment.h2': '筆記と実技の試験',
  'howToBecomeButler.assessment.h3': '再試験と準備',
  'howToBecomeButler.assessment.p1':
    '修了には出席率80％以上が必要です。実技は連続体験の中で身体に定着するため、欠席が続くと手順のつながりが切れやすくなります。やむを得ない事情でも早めに相談し、遅れの取り戻し方を具体化してください。出席は義務である以前に、安全な動作を反復する最低条件だと捉えると取り組み方が変わります。',
  'howToBecomeButler.assessment.p2':
    '評価は30分の筆記試験と実技試験で行います。筆記では用語、手順の意味、判断の要点など、行動の背景にある理解を確認します。実技では、定められた課題を落ち着いて遂行できるか、礼儀と安全が保てているかを見ます。暗記に偏らず、なぜその順番かを説明できる状態まで仕上げることが合格への近道です。',
  'howToBecomeButler.assessment.p3':
    '万一不合格でも、無料再試験は1回受けられます。落ち込みを引きずらす、不足した観点を振り返り、重点的に練習し直す期間として使ってください。再試験があるからと油断せず、初回で再現できる完成度を目指す方が定着は確実です。当日は体調と持ち物を整え、普段どおりの呼吸で臨む準備も評価の一部です。',

  'howToBecomeButler.certificate.title': '認定の意味と活用方法',
  'howToBecomeButler.certificate.intro':
    '修了後の認定は、一定の教育課程を終え定められた評価を通過したことを示します。肩書が仕事を保証するわけではなく、何を学びどの水準で確認されたかを第三者に説明する材料です。使い方を正しく理解し、過大にも過小にも扱わないことが、その後の信頼につながります。',
  'howToBecomeButler.certificate.h1': '民間資格としての位置づけ',
  'howToBecomeButler.certificate.p1':
    '当校の修了に伴う認定は、一般社団法人全日本執事協会による民間認定です。国家資格ではないため、法律上の独占業務や公的な就業資格を意味しません。それでも学習範囲と評価基準が明示されている点で、独学の自己申告より説明力が高まります。伝えるときは公的資格との違いを隠さず、学びの内容を具体的に補足してください。',
  'howToBecomeButler.certificate.h2': '学びを説明する証明',
  'howToBecomeButler.certificate.p2':
    '面接や初回の打ち合わせでは、認定名だけでなく、どのコースで何時間学び、どのような実技を経験したかを話せると説得力が増します。認定は入口の共通言語であり、実務能力の代替ではありません。得意領域や改善中の課題も添えて伝えると、期待値のズレを減らせます。証明を見せて終わりにせず、対話の起点として使いましょう。',
  'howToBecomeButler.certificate.h3': '卒業後も技能を磨く',
  'howToBecomeButler.certificate.p3':
    '認定取得は通過点です。住まいの様式、依頼主の好み、季節の行事は現場ごとに異なり、学校の型をそのまま当てはめれば足りるわけではありません。卒業後も基本動作を定期的に見直し、新しい用具やマナーの変化を学び続ける必要があります。小さな失敗を記録し次へ反映する習慣こそが、認定の価値を長く保つ実践です。',

  'howToBecomeButler.career.title': '仕事につなげる準備',
  'howToBecomeButler.career.intro':
    '学びを仕事へつなぐには、技能以外の準備も欠かせません。どの環境で誰のどんな課題を支えるかを具体化し、経験を相手に伝わる言葉へ翻訳する作業が必要です。養成機関は就職を約束する場ではなく、現場で通用する基礎と姿勢を整える場です。その前提を共有したうえで、現実的な次の一歩を設計します。',
  'howToBecomeButler.career.h1': '働く場所を具体的に知る',
  'howToBecomeButler.career.p1':
    '活躍の場は個人宅だけに限りません。別荘の管理、来客の多い家庭、高齢の依頼主の生活支援に近い環境など、求められる比重は場所ごとに変わります。体力、得意な時間帯、守秘への耐性を踏まえ、向いている条件を書き出してください。漠然と「執事になりたい」で止まらず、現場の一日の流れを想像できるまで調べることがミスマッチ防止になります。',
  'howToBecomeButler.career.h2': '経験を言葉にして伝える',
  'howToBecomeButler.career.p2':
    '接客業、事務、介護、家事代行など、過去の経験は一見遠くても、観察力や段取り、丁寧な報告といった共通点があります。履歴書や面談では、担当範囲、工夫した点、トラブル時の対応を短く具体的に述べます。養成で得た用語を使い、強みを執事の文脈へ翻訳できると、未経験でも話の筋が通りやすくなります。',
  'howToBecomeButler.career.h3': '採用保証ではないこと',
  'howToBecomeButler.career.p3':
    '修了や認定は学習成果を示すものであり、就職や採用を保証する制度ではありません。採用条件は勤務先ごとに異なり、人柄、健康、スケジュール適合、試用期間の評価など複合的に判断されます。保証がない事実を理解したうえで、自分で情報を集め、面談に臨み、必要なら追加の実務経験を積む計画を立てることが、長期的には近道になります。',

  'howToBecomeButler.start.title': '今日から始める手順',
  'howToBecomeButler.start.intro':
    '情報を集めたら、行動を小さな単位に分けて着手します。申込だけを急ぐより、目的の明確化、コース比較、日程と生活の調整を順に行う方が後悔が少なくなります。今日できることは、現状の整理と質問事項の書き出しです。準備が具体になるほど、説明会や個別相談でも本質的な確認ができます。',
  'howToBecomeButler.start.h1': '目的と現在地を整理する',
  'howToBecomeButler.start.p1':
    'なぜ執事を目指すのか、どの期間でどの水準まで到達したいかを、自分の言葉で書き出します。仕事や家庭の都合、体力、学習に割ける時間も正直に棚卸ししてください。理想だけが先行すると、コース選択や練習計画が現実と乖離します。到達したい姿と制約を並べることで、無理のない学習ペースが見えてきます。',
  'howToBecomeButler.start.h2': '説明を読み比較する',
  'howToBecomeButler.start.p2':
    'コース時間、評価方法、認定の位置づけ、就職保証がない点など、公開情報を一通り読み比べます。不明点は箇条書きにし、公式案内や相談の場で確認してください。口コミや印象だけで決めず、毎日続けられる内容かを基準にします。比較表をつくると感情的な判断が減り、納得して次の手続きへ進めます。',
  'howToBecomeButler.start.h3': '受講申込へ進む',
  'howToBecomeButler.start.p3':
    '目的と条件が固まったら、受講案内に沿って申込へ進みます。必要書類、日程、事前資料の有無を確認し、開始日までの生活リズムも先に調整してください。申込後は基礎的な敬語や身だしなみを自主的に整えておくと、初日から実技に集中しやすくなります。踏み出したあとも疑問は早めに質問し、学びを止めないことが大切です。',

  'howToBecomeButler.images.hero': '邸宅の玄関で来客を迎える執事',
  'howToBecomeButler.images.household': '邸宅管理の準備を確認する執事',
  'howToBecomeButler.images.table': 'テーブルサービスの所作を練習する受講生',
  'howToBecomeButler.images.curriculum': '執事教育の教材と実習風景',
  'howToBecomeButler.images.assessment': '実技評価に取り組む受講生',
  'howToBecomeButler.images.career': '執事として働く将来を考える受講生',
  'howToBecomeButler.links.curriculum': 'カリキュラムを見る',
  'howToBecomeButler.links.courses': 'コース一覧',
  'howToBecomeButler.links.certificate': '認定制度',
  'howToBecomeButler.links.job': '執事の仕事を詳しく知る',
  'howToBecomeButler.links.application': '受講案内・申込方法を見る',
  'howToBecomeButler.faq.q1': '未経験でも執事を目指せますか？',
  'howToBecomeButler.faq.a1':
    'はい。基礎から段階的に学べます。年齢や経歴だけで判断せず、学ぶ目的と継続して練習する意思を確認してください。',
  'howToBecomeButler.faq.q2': '各コースの期間は？',
  'howToBecomeButler.faq.a2':
    'エッセンシャルは8日間・48時間、アドバンスは12日間・72時間、マスターは16日間・96時間です。',
  'howToBecomeButler.faq.q3': '修了の条件は？',
  'howToBecomeButler.faq.a3':
    '出席率80％以上に加え、30分の筆記試験と実技試験があります。不合格の場合の無料再試験は1回です。',
  'howToBecomeButler.faq.q4': '国家資格ですか？',
  'howToBecomeButler.faq.a4': 'いいえ。一般社団法人全日本執事協会による民間認定です。',
  'howToBecomeButler.faq.q5': '卒業すれば就職できますか？',
  'howToBecomeButler.faq.a5':
    '就職や採用を保証する制度ではありません。認定は学習成果を示すもので、採用条件は勤務先ごとに異なります。',
};
export default m;
